<template>
  <div class="mb-2 p-4">
    <validation-observer ref="purchaseConfirmationForm" novalidate tag="form">
      <div class="row">
        <div class="col-12 mb-3">
          <icon-view
            :has-border="false"
            icon="fas fa-calendar-edit text-orange"
            title="Confirmar Compra"
            variant="custom-icon-view"
            icon-background="white"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12 col-md">
          <validation-provider
            mode="eager"
            rules="required"
            v-slot="{ errors }"
          >
            <custom-drop-down
              v-model="model.locationType"
              :options="locationTypes"
              label="Localidad:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="w-100 bold-label"
              custom-error-msg="Este campo es requerido"
              :error="errors[0]"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-md">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <div>
              <label class="color-secondary-6 font-14"
                >Número de Requisición:</label
              >
              <input
                :class="{ 'was-invalidated': errors.length != 0 }"
                class="form-control"
                v-model="model.requisitionNumber"
                type="text"
                label="Número de Requisición:"
                :error="errors[0]"
                maxlength="50"
              />
              <span
                v-if="errors.length != 0"
                class="custom-error-message font-14 ml-1"
              >
                <i class="fas fa-times-circle custom-error-message"></i> Este
                campo es requerido
              </span>
            </div>
          </validation-provider>
        </div>
        <div class="col-12 col-md">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <div>
              <label class="color-secondary-6 font-14">Número de PO:</label>
              <input
                :class="{ 'was-invalidated': errors.length != 0 }"
                class="form-control"
                v-model="model.purcharseOrderNumber"
                type="text"
                :error="errors[0]"
                maxlength="50"
              />
              <span
                v-if="errors.length != 0"
                class="custom-error-message font-14 ml-1"
              >
                <i class="fas fa-times-circle custom-error-message"></i> Este
                campo es requerido
              </span>
            </div>
          </validation-provider>
        </div>
        <div class="col-12 col-md">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-date-picker
              label="Fecha de PO:"
              v-model="model.actionDate"
              :min-date="initialDate"
              placeholder="DD/MM/YYYY"
              container-class="w-100"
              :error="errors[0]"
              custom-error-msg="Este campo es requerido"
            />
          </validation-provider>
        </div>
      </div>
      <custom-text-area
        show-char-count
        :maxlength="3000"
        placeholder="Escribe un comentario"
        label="Comentario:"
        v-model="model.comment"
        :count-classes="['d-block text-right']"
      />
    </validation-observer>
    <div class="d-flex justify-content-end align-items-center mt-4">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 px-3"
        @click="$emit('close')"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Guardar"
        variant="success px-3"
        @click="handlerSave"
      />
    </div>
  </div>
</template>
<script>
import ActionButton from "ActionButton";
import IconView from "icon-view";
import CustomTextArea from "CustomTextArea";
import CustomCallout from "custom-callout";
import CustomResultNotFound from "custom-result-not-found";
import CustomDatePicker from "custom-date-picker";
import CustomDropDown from "custom-drop-down";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin.js";
import CustomInput from "CustomInput";
import moment from "moment";
import LocationTypes from "@/utils/constants/inventory/inventoryOrderBookLocationTypes";

export default {
  name: "customRequestForm",
  components: {
    ActionButton,
    IconView,
    CustomTextArea,
    CustomCallout,
    CustomResultNotFound,
    CustomDatePicker,
    CustomInput,
    CustomDropDown
  },
  mixins: [alertMixin],
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  watch: {
    "model.requisitionNumber"(newValue, oldValue) {
      this.model.requisitionNumber = this.filterNumbers(newValue);
    },
    "model.purcharseOrderNumber"(newValue, oldValue) {
      this.model.purcharseOrderNumber = this.filterNumbers(newValue);
    }
  },
  data() {
    return {
      model: {
        comment: null,
        actionDate: null,
        requisitionNumber: null,
        purcharseOrderNumber: null,
        locationType: null
      }
    };
  },
  computed: {
    initialDate() {
      return moment(Date.now())
        .subtract(2, "months")
        .format("YYYY-MM-DD");
    },
    locationTypes() {
      return [LocationTypes.CSEE, LocationTypes.CENTER, LocationTypes.SCHOOL];
    }
  },

  methods: {
    filterNumbers(value) {
      // Filtra el valor para mantener solo números del 0 al 9
      return value ? value.replace(/\D/g, "") : "";
    },
    async handlerSave() {
      const isvalid = await this.$refs.purchaseConfirmationForm.validate();
      if (!isvalid) {
        this.ShowToast(
          "Alerta",
          "Por favor completa los campos requeridos.",
          "error"
        );
        return;
      }

      const confirmed = await this.ShowCancelModal(
        "Confirmación",
        `¿Está seguro que desea guardar la información documentada?`,
        "Sí",
        "No"
      );

      if (!confirmed) return;

      const payload = {
        id: this.order.id,
        actionDate: this.model.actionDate,
        comment: this.model.comment,
        requisitionNumber: this.model.requisitionNumber,
        purchaseConfirmationNumber: this.model.purcharseOrderNumber,
        bookTitle: this.order.book.name,
        locationTypeId: this.model.locationType.id
      };

      this.$emit("save", payload);
    }
  }
};
</script>
<style lang="scss" scoped>
.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.custom-error-message {
  color: #ff5b5c;
  font-size: 18px;
  padding-right: 10px;
}
.was-invalidated {
  border: 1px solid #ff0018 !important;
  background-color: #f7d7da !important;
}
</style>
